import { faChevronLeft, faChevronRight, faExternalLink } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { QRCodeSVG } from 'qrcode.react';
import React, { FC, useEffect, useState } from 'react';
import { fetchPickupWorks, Work } from './api';
import { WorkTaxonomies } from './list';
import { isMobile } from './utils';
import styles from './work.module.scss';

const imageUrl = (work: Work) =>
  work.meta.imageUrlPickup ?? work.meta.imageUrl ?? 'https://ralsnet.jp/resources/common/img/noimage.png';

const mobileUrl = (work: Work) => (work.meta.otherLinkMobile ? work.meta.otherLinkMobile : work.meta.otherLink);
const url = (work: Work) => (isMobile() ? mobileUrl(work) : work.meta.otherLink);

export const PickupWorks: FC = () => (
  <section>
    <h1 className={styles.sectionTitle}>ピックアップ事例</h1>
    <PickupCarousel />
  </section>
);

export const PickupCarousel: FC = () => {
  const [works, setWorks] = useState<Work[]>([]);
  const [loading, setLoading] = useState(true);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const controller = new AbortController();

    (async () => {
      const res = await fetchPickupWorks(controller.signal);
      setWorks(res.body);
      setLoading(false);
    })();

    return () => {
      controller.abort();
    };
  }, []);

  if (loading) {
    return (
      <div className={`${styles.pickupCarousel} ${styles.skelton}`}>
        <div className={styles.pickup}>
          <div className={styles.pickupImage}> </div>
          <div className={styles.pickupText}>
            <div className={styles.pickupTitle}> </div>
            <div className={styles.pickupTaxonomies}>
              <span className={styles.pickupTaxonomy}> </span>
              <span className={styles.pickupTaxonomy}> </span>
              <span className={styles.pickupTaxonomy}> </span>
            </div>
          </div>
        </div>
        <div className={styles.pickupCarouselDots}> </div>
      </div>
    );
  }

  return (
    <div className={styles.pickupCarousel}>
      {works.map((work, i) => (
        <div key={work.id} id={`work-${work.id}`} className={styles.pickup} aria-current={i === index}>
          <div className={styles.pickupImage}>
            <img src={imageUrl(work)} alt='' />
            {!isMobile() && <QRCodeSVG value={mobileUrl(work)} includeMargin className={styles.workQR} />}
          </div>
          <div className={styles.pickupText}>
            <a
              href={url(work)}
              target='_blank'
              className={styles.pickupTitle}
              tabIndex={i === index ? 0 : -1}
              rel='noreferrer'
            >
              {work.meta.purpose}
              <FontAwesomeIcon icon={faExternalLink} className={styles.pickupExternalLinkIcon} />
            </a>
            <WorkTaxonomies
              work={work}
              wrapClass={styles.pickupTaxonomies}
              taxonomyClass={styles.pickupTaxonomy}
              termClass={styles.pickupTerm}
            />
            <p className={styles.pickupComment}>{work.meta.comment}</p>
          </div>
        </div>
      ))}
      <div className={styles.pickupCarouselDots}>
        <button
          type='button'
          className={styles.pickupCarouselArrow}
          onClick={() => setIndex((state) => Math.max(0, state - 1))}
        >
          <FontAwesomeIcon icon={faChevronLeft} />
        </button>

        {works.map((work, i) => (
          <button
            key={`${work.id}-dot`}
            className={styles.pickupCarouselDot}
            type='button'
            onClick={() => setIndex(i)}
            aria-current={i === index}
            aria-controls={`work-${work.id}`}
          >
            ●
          </button>
        ))}

        <button
          type='button'
          className={styles.pickupCarouselArrow}
          onClick={() => setIndex((state) => Math.min(works.length - 1, state + 1))}
        >
          <FontAwesomeIcon icon={faChevronRight} />
        </button>
      </div>
    </div>
  );
};
